// test1361
(1361 && 0);
